import { Fragment, useContext, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon } from "@heroicons/react/outline";
import AuthContext from "../../AuthContext";
import {toast} from 'react-toastify' 
import axiosInstance from '../../axios'
import Centre from '../Dropdowns/Centre'

export default function AddProduct({
  addProductModalSetting,
  handlePageUpdate,
}) {
  const authContext = useContext(AuthContext);
  const [open, setOpen] = useState(true);
  const cancelButtonRef = useRef(null);
  const[centre,setCentre]=useState(null)
  const[file,setFile]=useState('')
  const[order,setOrder]=useState({
    client_details:'',
    remarks :'',
    location_of_project :'',
    total_target :'',
    cost_of_project:'',
    name_of_programe:'',
    sanction_no:'',
    financial_year :'',
    duration:''

  })
  const orders=true
  const center=authContext.userType==='Admin'?authContext.centre:centre
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setOrder(prevState => ({
      ...prevState,
      [name]: value
    }));
  }
  const imp=true
 const addOrder = () => {
  // Check if all fields in the order object are empty
  const isOrderEmpty = Object.values(order).every(
    (value) => value === '' || value === null
  );

  // Check if centre is required and empty
  const isCentreEmpty = (authContext.userType === 'Superadmin' || authContext.userType === 'Manager') && !centre;

  // If all fields are empty or centre is empty when required, show error and prevent submission
  if (isOrderEmpty || isCentreEmpty) {
    toast.error('Please fill in at least one field');
    return;
  }

  axiosInstance
    .post(`sanctionorder/insert`, {
      centre_id: center,
      sanction_order_no: order.sanction_no,
      client_details: order.client_details,
      tot_training_target_allocated: order.total_target,
      name_of_training_program: order.name_of_programe,
      project_duration: order.duration,
      project_cost: order.cost_of_project,
      project_location: order.location_of_project,
      remark: order.remarks,
      financial_year: order.financial_year,
    })
    .then((res) => {
      toast.success('Sanction Order Added');
      addProductModalSetting();
      handlePageUpdate();
    })
    .catch((err) => toast.error('Something Went Wrong'));
};
  return (
    // Modal
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                      <PlusIcon
                        className="h-6 w-6 text-blue-400"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left ">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-semibold leading-6 text-gray-900 "
                      >
                        Add Sanction Order
                      </Dialog.Title>
                      <form action="#" aria-autocomplete="true">
                        <div className="grid gap-4 mb-4 sm:grid-cols-4">
   {(authContext.userType==='Superadmin'||authContext.userType==='Manager')&&
   <Centre value={centre} handleInputChange={(e)=>setCentre(e.target.value)} orders={orders} />}
                            
                        <div>
                              <label htmlFor="financial_year"
                              className="block mt-3 mb-4 text-sm font-medium text-gray-900 dark:text-white">
                                Financial Year </label>
                            <input
                            type="text"
                            id="financial_year"
                            name="financial_year"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
  focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
   value={order.financial_year}
                            onChange={handleInputChange}
                            />

                            </div>
                            <div>
                              <label htmlFor="sanction_no"
                              className="block mt-3 mb-4 text-sm font-medium text-gray-900 dark:text-white">
                                Sanction No. </label>
                            <input
                            type="number"
                            id="sanction_no"
                            name="sanction_no"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
  focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
   value={order.sanction_no}
                            onChange={handleInputChange}
                            />
                            </div>
                         
                            
                       
                          
                           
                            <div>
                              <label htmlFor="client_details"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                              >Client Details/ Sponsoring Agency
                               </label>
                            <input
                            type="text"
                            id="client_details"
                            name="client_details"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
  focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
   value={order.client_details}
                            onChange={handleInputChange}
                            />
                            </div>
                            <div>
                              <label htmlFor="total_target"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Total Training Target Allocated
                                </label>
                            <input
                            type="number"
                            id="total_target"
                            name="total_target"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
  focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                             
   value={order.total_target}
                            onChange={handleInputChange}
                            />
                            </div>
                           
                            <div>
                              <label htmlFor="name_of_programe"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                Name of the Training Programme</label>
                            <input
                            type="text"
                            id="name_of_programe"
                            name="name_of_programe"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
  focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
   value={order.name_of_programe}
                            onChange={handleInputChange}
                            />
                            </div>
                            <div>
                              <label htmlFor="location_of_project"
                              className="block mt-3 mb-4 text-sm font-medium text-gray-900 dark:text-white">
                                Location of the Project </label>
                            <input
                            type="text"
                            id="location_of_project"
                            name="location_of_project"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
  focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
   value={order.location_of_project}
                            onChange={handleInputChange}
                            />

                            </div>
                            <div>
                              <label htmlFor="cost_of_project"
                              className="block mt-3 mb-4 text-sm font-medium text-gray-900 dark:text-white">
                                Cost of the Project
                              </label>
                            <input
                            type="number"
                            id="cost_of_project"
                            name="cost_of_project"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
  focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
   value={order.cost_of_project}
                            onChange={handleInputChange}
                            />

                            </div>
                            <div>
                              <label htmlFor="duration"
                              className="block mt-3 mb-4 text-sm font-medium text-gray-900 dark:text-white">
                              Duration of Project </label>
                            <input
                            type="text"
                            id="duration"
                            name="duration"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
  focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
   value={order.duration}
                            onChange={handleInputChange}
                            />
                            </div> 
                            <div>
                              <label htmlFor="remarks"
                              className="block mt-3 mb-4 text-sm font-medium text-gray-900 dark:text-white">
                              Remarks </label>
                            <input
                            type="text"
                            id="remarks"
                            name="remarks"
 className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600
  focus:border-blue-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400
   dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"                            
   value={order.remarks}
                            onChange={handleInputChange}
                            />
                            </div> 
                          </div>
                          
                                <div className="flex items-center space-x-4">
                                
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                          <button
                            type="button"
                            className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                            onClick={addOrder}
                          >
                            Add Order
                          </button>
                          <button
                            type="button"
                            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                            onClick={() => addProductModalSetting()}
                            ref={cancelButtonRef}
                          >
                            Cancel
                          </button>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </Dialog>
            </Transition.Root>
          );
        }
